export class PasswordReset {
    email: string | undefined;
    captcha?: string;
    applicationId?: string;
}